import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpandableToFullHeight } from "@faire/retailer-visitor-shared/components/ExpandableToFullHeight/ExpandableToFullHeight";
import { Filter } from "@faire/retailer-visitor-shared/components/Filters/Filter";
import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { LeftCategoryNavigation } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/LeftNav/LeftCategoryNavigation";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";
export var LoggedOutCategoryPageFilterSidebar = function(param) {
    var className = param.className;
    var categoryModel = useLoggedOutCategoryPageCurrentCategory();
    var totalPrimaryResultsCount = useLoggedOutCategoryPageCatNavResponse().data.totalPrimaryResultsCount;
    var _useFilterStore = useFilterStore([
        "isSideBarVisible"
    ]), isSideBarVisible = _useFilterStore.data.isSideBarVisible;
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    if (isSideBarVisible || isTabletAndBelow) {
        return /*#__PURE__*/ _jsxs(SidebarContainerWithFilters, {
            className: className,
            children: [
                /*#__PURE__*/ _jsx(ExpandableToFullHeight, {
                    children: /*#__PURE__*/ _jsx(LeftCategoryNavigation, {
                        selectedCategory: categoryModel
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(Filter, {
                    name: FilterName.LOGGED_OUT_CATEGORY,
                    resultsCount: totalPrimaryResultsCount,
                    headerSeparator: true,
                    isSticky: true
                })
            ]
        });
    }
    return null;
};
// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
var SidebarContainerWithFilters = styled(Column).withConfig({
    componentId: "sc-8c0f17cc-0"
})([
    "flex:0 0 228px;margin-right:",
    ";&&&{",
    "{display:none;}}"
], getSpacing("6x"), responsiveMediaQueries.tabletAndBelow);
